import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "receive-nft-comp send-nft-confirm-comp" }
const _hoisted_2 = { class: "nft-card-row" }
const _hoisted_3 = { class: "content-area" }
const _hoisted_4 = { class: "text-box" }
const _hoisted_5 = { class: "profile-row" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "button-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nft_card_comp = _resolveComponent("nft-card-comp")!
  const _component_mv_button = _resolveComponent("mv-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.info)
        ? (_openBlock(), _createBlock(_component_nft_card_comp, {
            key: 0,
            data: _ctx.cardInfo,
            "flip-lock": true
          }, null, 8, ["data"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.getProfileSrc(_ctx.info.sender.profileImg)
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('receiveNtfc.nftReceive.text', {
                  sender: _ctx.info.sender.name,
                  name: `${ _ctx.info.cltnName } ${_ctx.info.name}`,
                  type: _ctx.$t(`nftType.${_ctx.info.cltnType}`),
                })), 1),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_mv_button, {
          type: "round-black",
          text: "common.ok",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('ok')))
        })
      ])
    ])
  ]))
}